import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import AdminLayout from './layouts/AdminLayout';
import ErrorBoundary from './components/ErrorBoundary';

// Pages
import Login from './pages/Login';
import ErrorPage from './pages/ErrorPage';
import Dashboard from './pages/Dashboard';
import UserList from './pages/users/UserList';
import UserDetail from './pages/users/UserDetail';
import StaffList from './pages/staff/StaffList';
import AstrologerList from './pages/astrologers/AstrologerList';
import AstrologerDetail from './pages/astrologers/AstrologerDetail';
import KYCVerification from './pages/astrologers/KYCVerification';
import ChatLogs from './pages/chat/ChatLogs';
import Transactions from './pages/wallet/Transactions';
import CoinManagement from './pages/wallet/CoinManagement';
import ProductList from './pages/shop/ProductList';
import ProductForm from './pages/shop/ProductForm';
import OrderList from './pages/shop/OrderList';
import OrderDetail from './pages/shop/OrderDetail';
import CourseList from './pages/courses/CourseList';
import CourseForm from './pages/courses/CourseForm';
import BlogList from './pages/blog/BlogList';
import BlogForm from './pages/blog/BlogForm';
import CommissionSettings from './pages/commissions/CommissionSettings';
import RevenueReport from './pages/reports/RevenueReport';
import GSTReport from './pages/reports/GSTReport';
import TDSReport from './pages/reports/TDSReport';
import GeneralSettings from './pages/settings/GeneralSettings';
import PaymentSettings from './pages/settings/PaymentSettings';
import CurrencySettings from './pages/settings/CurrencySettings';
import NotificationSettings from './pages/settings/NotificationSettings';
import LiveStreams from './pages/live/LiveStreams';
import TicketList from './pages/support/TicketList';
import TicketDetail from './pages/support/TicketDetail';
import PayoutList from './pages/payouts/PayoutList';
import InviteAstrologer from './pages/astrologers/InviteAstrologer';
import RegisterAstrologer from './pages/astrologers/RegisterAstrologer';

const ProtectedRoute = ({ children }) => (
  <AdminLayout>{children}</AdminLayout>
);

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ThemeProvider>
          <AuthProvider>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/users" element={<ProtectedRoute><UserList /></ProtectedRoute>} />
              <Route path="/users/:id" element={<ProtectedRoute><UserDetail /></ProtectedRoute>} />
              <Route path="/staff" element={<ProtectedRoute><StaffList /></ProtectedRoute>} />
              <Route path="/astrologers" element={<ProtectedRoute><AstrologerList /></ProtectedRoute>} />
              <Route path="/astrologers/:id" element={<ProtectedRoute><AstrologerDetail /></ProtectedRoute>} />
              <Route path="/astrologers/kyc" element={<ProtectedRoute><KYCVerification /></ProtectedRoute>} />
              <Route path="/astrologers/invite" element={<ProtectedRoute><InviteAstrologer /></ProtectedRoute>} />
              <Route path="/astrologers/register" element={<ProtectedRoute><RegisterAstrologer /></ProtectedRoute>} />
              <Route path="/chat-logs" element={<ProtectedRoute><ChatLogs /></ProtectedRoute>} />
              <Route path="/transactions" element={<ProtectedRoute><Transactions /></ProtectedRoute>} />
              <Route path="/wallet/coins" element={<ProtectedRoute><CoinManagement /></ProtectedRoute>} />
              <Route path="/shop/products" element={<ProtectedRoute><ProductList /></ProtectedRoute>} />
              <Route path="/shop/products/new" element={<ProtectedRoute><ProductForm /></ProtectedRoute>} />
              <Route path="/shop/products/:id/edit" element={<ProtectedRoute><ProductForm /></ProtectedRoute>} />
              <Route path="/shop/orders" element={<ProtectedRoute><OrderList /></ProtectedRoute>} />
              <Route path="/shop/orders/:id" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
              <Route path="/courses" element={<ProtectedRoute><CourseList /></ProtectedRoute>} />
              <Route path="/courses/new" element={<ProtectedRoute><CourseForm /></ProtectedRoute>} />
              <Route path="/courses/:id/edit" element={<ProtectedRoute><CourseForm /></ProtectedRoute>} />
              <Route path="/commissions" element={<ProtectedRoute><CommissionSettings /></ProtectedRoute>} />
              <Route path="/reports/revenue" element={<ProtectedRoute><RevenueReport /></ProtectedRoute>} />
              <Route path="/reports/gst" element={<ProtectedRoute><GSTReport /></ProtectedRoute>} />
              <Route path="/reports/tds" element={<ProtectedRoute><TDSReport /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><GeneralSettings /></ProtectedRoute>} />
              <Route path="/settings/payment" element={<ProtectedRoute><PaymentSettings /></ProtectedRoute>} />
              <Route path="/settings/currency" element={<ProtectedRoute><CurrencySettings /></ProtectedRoute>} />
              <Route path="/settings/notifications" element={<ProtectedRoute><NotificationSettings /></ProtectedRoute>} />
              <Route path="/blogs" element={<ProtectedRoute><BlogList /></ProtectedRoute>} />
              <Route path="/blogs/new" element={<ProtectedRoute><BlogForm /></ProtectedRoute>} />
              <Route path="/blogs/:id/edit" element={<ProtectedRoute><BlogForm /></ProtectedRoute>} />
              <Route path="/support/tickets" element={<ProtectedRoute><TicketList /></ProtectedRoute>} />
              <Route path="/support/tickets/:id" element={<ProtectedRoute><TicketDetail /></ProtectedRoute>} />
              <Route path="/live-streams" element={<ProtectedRoute><LiveStreams /></ProtectedRoute>} />
              <Route path="/payouts" element={<ProtectedRoute><PayoutList /></ProtectedRoute>} />
              <Route path="*" element={<ProtectedRoute><ErrorPage /></ProtectedRoute>} />
            </Routes>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
